import { ClarificationQuestion } from '../../types/chatTypes'

// The Q:/A: text and the `[No preference]` / `(Select all that apply)` literals
// are read by the agent's prompt, not by code: they stay English and unchanged
// whatever UI language is active.

// One slot per question. `none` is the "no answer" state (untouched OR
// explicitly skipped) and serializes to `[No preference]` in the Q:/A: string.
export type Selection =
  | { kind: 'none' }
  | { kind: 'pick'; values: string[] }
  | { kind: 'custom'; text: string }

export const hasAnswer = (s: Selection): boolean => {
  if (s.kind === 'pick') return s.values.length > 0
  if (s.kind === 'custom') return s.text.trim().length > 0
  return false
}

export const countSelected = (s: Selection): number => {
  if (s.kind === 'pick') return s.values.length
  if (s.kind === 'custom') return s.text.trim() ? 1 : 0
  return 0
}

export const formatQA = (
  questions: ClarificationQuestion[],
  selections: Selection[],
): string =>
  questions
    .map((q, i) => {
      const heading =
        q.prompt + (q.type === 'multi_select' ? ' (Select all that apply)' : '')
      return `Q: ${heading}\nA: ${answerFor(selections[i])}`
    })
    .join('\n\n')

const NO_PREFERENCE_ANSWER = '[No preference]'

export const answerFor = (s: Selection): string => {
  if (s.kind === 'pick') return s.values.join(', ')
  if (s.kind === 'custom') return s.text.trim() || NO_PREFERENCE_ANSWER
  return NO_PREFERENCE_ANSWER
}
